import { useEffect } from "react";
import { getgiftCard } from "../store/slices/giftCardSlice";
import { useDispatch, useSelector } from "react-redux";

export const useGiftCard = () => {
  const dispatch = useDispatch();
  const giftCardData = useSelector((state) => state.giftCard);
  const authStatus = useSelector((state) => state.token.status);

  useEffect(() => {
    if (authStatus === "succeeded" && giftCardData.status === "idle") {
      dispatch(getgiftCard());
    }
  }, [authStatus]);

  return {
    giftCardData: giftCardData?.giftCardData,
  };
};
